import React, { useEffect, useState } from "react";
import styles from "./EventsUpcomingEvents.module.css";
import Image from "next/image";
import Link from "next/link";
import { extractMonthAndDateAndTime } from "@/utils/utils";
import Pagination from "../Pagination/Pagination";
import { Clock } from "lucide-react";

interface Props {
  title: string;
  data: any;
}

const EventsUpcomingEvents: React.FC<Props> = ({ title, data }: Props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const itemsPerPage = isMobile ? 4 : 4;
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedItems = data?.feature_event_cards.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const scrollToTop = () => {
    const topElement = document.getElementById("top");
    if (topElement) {
      topElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div className={styles.upcoming_container} id="top">
      <div className="container">
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.eventList}>
          {selectedItems?.map((event: any, index: number) => {
            const isLastItem = index === selectedItems.length - 1;
            const date = event?.event_card?.date_time;
            const { formattedNewDate, formattedNewMonth, formatTime } =
              extractMonthAndDateAndTime(date);

            return (
              <Link
                className={styles.eventTitle}
                href={event?.type_link?.url || ""}
                key={event?.id}
              >
                <div
                  className={`${styles.eventItem} ${
                    isLastItem ? styles.lastEventItem : ""
                  }`}
                >
                  <div className={styles.dateContainer}>
                    <div className={styles.month}>{formattedNewMonth}</div>
                    <div className={styles.day}>{formattedNewDate}</div>
                  </div>
                  <div className={styles.eventDetails}>
                    <strong className={styles.eventType}>
                      {event?.type_link?.label}
                    </strong>
                    <h4>{event?.event_card?.title}</h4>
                    <div className={styles.eventMeta}>
                      <div className={styles.metaItem}>
                        <Clock className={styles.icon} />
                        <span> {formatTime.toLowerCase()}</span>
                      </div>
                      <div className={styles.metaItem}>
                        <Image
                          src="/assets/location_gray.svg"
                          alt="Event"
                          title="Event"
                          width={20}
                          className={styles.icon}
                          height={20}
                        />
                        <span>{event?.event_card?.location}</span>
                      </div>
                    </div>
                  </div>
                  <div className={styles.eventImage}>
                    <Image
                      src={event?.image?.url}
                      alt={event?.event_card?.title}
                      title={event?.event_card?.title}
                      width={112}
                      height={112}
                      className={styles.image}
                      priority
                    />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        {data?.feature_event_cards?.length > itemsPerPage && (
          <Pagination
            isEvent
            totalItems={data?.feature_event_cards?.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            scrollToTop={scrollToTop}
          />
        )}
      </div>
    </div>
  );
};

export default EventsUpcomingEvents;
